// Profile.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Profile.css';
// import axios from 'axios';
import { jwtDecode } from 'jwt-decode'

const Profile = () => {
  const [user, setUser] = useState({name:"", email:"", role:""});

  
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      const decodedToken = jwtDecode(token);
      const fetchUser = async () => {
        try {
          const headers = {
            'Authorization': localStorage.getItem("token"),
            'Content-Type': 'application/json',
          };
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/v1/users/${decodedToken.sub}`,{headers});
          console.log(response)
          // data.append({name: response.data.name});
          // data.name = response.data.name;
          const data = {
            name: response.data.name,
            email: decodedToken.sub,
            role: decodedToken.role,
          }
          setUser(data);  
        } catch (error) {
          console.error('Error fetching user:', error);
        }
      };

      fetchUser()
    }
  }, []);

  return (
    <div>
      <ul className="nav-links">
        <li><a href={user.role.toLowerCase()}>Easy<span style={{ color: '#8968FF' }}>Exit</span></a></li>
        <li className="profile-icon" style={{ color: '#8968FF', fontSize: '35px', marginLeft: '87%' }}>
          <i className='bx bx-user'></i>
        </li>
      </ul>

      <div className="profile-card">
        <div className="image">
          <img src="image.jpg" alt="" style={{ width: "inherit" }} />   
        </div>

        <div className="text-data">
          <span className="name"><span class="name-text">Name:</span>{user.name}</span>
          <span className="email"><span class="name-text">Email id:</span>{user.email}@iiita.ac.in</span>
          <span className="prof"><span class="name-text">Logged in as:</span>{user.role}</span>
        </div>
      </div>
    </div>
  );
};

export default Profile;
